module.exports = __webpack_public_path__ + "media/virtualStagingContractMedia/virtualStagingMedia3-aec52872.jpeg";